import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Paper } from '@mui/material';
import clsx from 'clsx';
import { forwardRef } from 'react';

const Wrapper = forwardRef(function Card(_a, ref) {
    var { children, variant = "elevated", component, className, gutterBottom } = _a, rest = __rest(_a, ["children", "variant", "component", "className", "gutterBottom"]);
    return (jsx(CardRoot, Object.assign({ "$gutterBottom": gutterBottom, className: clsx("VoltCard-root", className), component: component, ref: ref, variant: variant === "flat" ? "outlined" : undefined }, rest, { children: children })));
});
const WrapperTyped = Wrapper;
const CardRoot = styled(Paper)(({ $gutterBottom, theme }) => (Object.assign({}, ($gutterBottom && {
    marginBottom: theme.spacing(4),
}))));

export { WrapperTyped as Wrapper };
//# sourceMappingURL=CardWrapper.js.map
